// extracted by mini-css-extract-plugin
module.exports = {"edgeButton":"styles-module_edgeButton_2IsJd","moveToEdgeButton":"styles-module_moveToEdgeButton_18H8Z"};